module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_8023.f576fcd0.png";